export default __webpack_public_path__ + "static/pha-fa2c788d088cc7b200fadc96bfcbf6ad.png";